import { toURLSearchParams } from '@wix/metro-runtime';
import { resolveUrl } from '@wix/metro-runtime';
function resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl(opts) {
    const domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/cloud-data',
                destPath: '',
            },
        ],
        'code._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/v1/connector',
                destPath: '/v1/connector',
            },
            {
                srcPath: '/_api/data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/v1/connector',
                destPath: '/v1/connector',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
        ],
        'cloud-data.wix-code.com': [
            {
                srcPath: '',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
            {
                srcPath: '/_api/data',
                destPath: '',
            },
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/cloud-data/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/cloud-data/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
            {
                srcPath: '/_api/data',
                destPath: '',
            },
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/_api/cloud-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/_api/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
            {
                srcPath: '/_api/cloud-data/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/_api/cloud-data/v2/bulk',
                destPath: '/v2/bulk',
            },
            {
                srcPath: '/_api/cloud-data/v2/items',
                destPath: '/v2/items',
            },
            {
                srcPath: '/_api/cloud-data/v2/dbs/tasks',
                destPath: '/v2/dbs/tasks',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/_api/cloud-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/_api/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
            {
                srcPath: '/_api/cloud-data/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/_api/cloud-data/v2/bulk',
                destPath: '/v2/bulk',
            },
            {
                srcPath: '/_api/cloud-data/v2/items',
                destPath: '/v2/items',
            },
            {
                srcPath: '/_api/cloud-data/v2/dbs/tasks',
                destPath: '/v2/dbs/tasks',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/_api/cloud-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/_api/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
            {
                srcPath: '/_api/cloud-data/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/_api/cloud-data/v2/bulk',
                destPath: '/v2/bulk',
            },
            {
                srcPath: '/_api/cloud-data/v2/items',
                destPath: '/v2/items',
            },
            {
                srcPath: '/_api/cloud-data/v2/dbs/tasks',
                destPath: '/v2/dbs/tasks',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/wix-data/v1/collections',
                destPath: '/v1/wix-data/collections',
            },
            {
                srcPath: '/wix-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/wix-data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/wix-data/v1/items',
                destPath: '/v1/items',
            },
            {
                srcPath: '/wix-data/v1/bulk',
                destPath: '/v1/bulk',
            },
            {
                srcPath: '/wix-data/v1/external-databases',
                destPath: '/v1/external-databases',
            },
            {
                srcPath: '/wix-data/v2',
                destPath: '/v2',
            },
        ],
        'www.wixgateway.com': [
            {
                srcPath: '/wix-data/v1/items',
                destPath: '/v1/items',
            },
            {
                srcPath: '/wix-data/v1/bulk',
                destPath: '/v1/bulk',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
/** Retrieves an external database connection by name. */
export function getExternalDatabaseConnection(payload) {
    function __getExternalDatabaseConnection({ host }) {
        const metadata = {
            entityFqdn: 'wix.data.v1.external_database_connection',
            method: 'GET',
            methodFqn: 'com.wixpress.cloud.data.api.externaldatabase.ExternalDatabaseConnectionService.GetExternalDatabaseConnection',
            url: resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl({
                protoPath: '/v1/external-database-connections/{name}',
                data: payload,
                host,
            }),
            params: toURLSearchParams(payload),
        };
        return metadata;
    }
    return __getExternalDatabaseConnection;
}
/** Retrieves a list of all external database collections associated with the site or project. */
export function listExternalDatabaseConnections(payload) {
    function __listExternalDatabaseConnections({ host }) {
        const metadata = {
            entityFqdn: 'wix.data.v1.external_database_connection',
            method: 'GET',
            methodFqn: 'com.wixpress.cloud.data.api.externaldatabase.ExternalDatabaseConnectionService.ListExternalDatabaseConnections',
            url: resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl({ protoPath: '/v1/external-database-connections', data: payload, host }),
            params: toURLSearchParams(payload),
        };
        return metadata;
    }
    return __listExternalDatabaseConnections;
}
/**
 * Creates a new external database connection.
 *
 * The `externalDatabaseConnection` parameter must include a `name`, `endpoint`, and `configuration` details for the external database.
 * If any of these are missing, the external database connection isn't created.
 */
export function createExternalDatabaseConnection(payload) {
    function __createExternalDatabaseConnection({ host }) {
        const metadata = {
            entityFqdn: 'wix.data.v1.external_database_connection',
            method: 'POST',
            methodFqn: 'com.wixpress.cloud.data.api.externaldatabase.ExternalDatabaseConnectionService.CreateExternalDatabaseConnection',
            url: resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl({ protoPath: '/v1/external-database-connections', data: payload, host }),
            data: payload,
        };
        return metadata;
    }
    return __createExternalDatabaseConnection;
}
/**
 * Updates an external database connection.
 *
 * An external database collection name must be provided in `name`.
 * If an existing external database connection is found with the same name, that connection's details are updated.
 * If no external database connection has that name, the request fails.
 *
 * > **Note:** After an external database connection is updated, it only contains the values provided in the request. All previous values are lost.
 */
export function updateExternalDatabaseConnection(payload) {
    function __updateExternalDatabaseConnection({ host }) {
        const metadata = {
            entityFqdn: 'wix.data.v1.external_database_connection',
            method: 'PUT',
            methodFqn: 'com.wixpress.cloud.data.api.externaldatabase.ExternalDatabaseConnectionService.UpdateExternalDatabaseConnection',
            url: resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl({
                protoPath: '/v1/external-database-connections/{externalDatabaseConnection.name}',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __updateExternalDatabaseConnection;
}
/**
 * Deletes an external database connection.
 *
 * > **Note:** Once an external database connection is deleted, it can't be restored. To reconnect the database you need to create a new external database connection.
 */
export function deleteExternalDatabaseConnection(payload) {
    function __deleteExternalDatabaseConnection({ host }) {
        const metadata = {
            entityFqdn: 'wix.data.v1.external_database_connection',
            method: 'DELETE',
            methodFqn: 'com.wixpress.cloud.data.api.externaldatabase.ExternalDatabaseConnectionService.DeleteExternalDatabaseConnection',
            url: resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl({
                protoPath: '/v1/external-database-connections/{name}',
                data: payload,
                host,
            }),
            params: toURLSearchParams(payload),
        };
        return metadata;
    }
    return __deleteExternalDatabaseConnection;
}
//# sourceMappingURL=data-v1-external-database-connection-external-database-connections.http.js.map